var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 8,
    viewBox: "0 0 101 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M100.354 4.35355C100.549 4.15829 100.549 3.84171 100.354 3.64645L97.1716 0.464466C96.9763 0.269204 96.6597 0.269204 96.4645 0.464466C96.2692 0.659728 96.2692 0.976311 96.4645 1.17157L99.2929 4L96.4645 6.82843C96.2692 7.02369 96.2692 7.34027 96.4645 7.53553C96.6597 7.7308 96.9763 7.7308 97.1716 7.53553L100.354 4.35355ZM0 4.5H100V3.5H0V4.5Z",
    className: "iconFill"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAxIiBoZWlnaHQ9IjgiIHZpZXdCb3g9IjAgMCAxMDEgOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEwMC4zNTQgNC4zNTM1NUMxMDAuNTQ5IDQuMTU4MjkgMTAwLjU0OSAzLjg0MTcxIDEwMC4zNTQgMy42NDY0NUw5Ny4xNzE2IDAuNDY0NDY2Qzk2Ljk3NjMgMC4yNjkyMDQgOTYuNjU5NyAwLjI2OTIwNCA5Ni40NjQ1IDAuNDY0NDY2Qzk2LjI2OTIgMC42NTk3MjggOTYuMjY5MiAwLjk3NjMxMSA5Ni40NjQ1IDEuMTcxNTdMOTkuMjkyOSA0TDk2LjQ2NDUgNi44Mjg0M0M5Ni4yNjkyIDcuMDIzNjkgOTYuMjY5MiA3LjM0MDI3IDk2LjQ2NDUgNy41MzU1M0M5Ni42NTk3IDcuNzMwOCA5Ni45NzYzIDcuNzMwOCA5Ny4xNzE2IDcuNTM1NTNMMTAwLjM1NCA0LjM1MzU1Wk0wIDQuNUgxMDBWMy41SDBWNC41WiIgY2xhc3M9Imljb25GaWxsIiAvPgo8L3N2Zz4K";
export { ForwardRef as ReactComponent };